export interface CliDocsSection {
  title: string
  commands: Array<{ cmd: string; desc: string }>
}

export const CLI_DOCS_SECTIONS: CliDocsSection[] = [
  {
    title: 'Installation',
    commands: [{ cmd: 'npm install -g @agentwiki/cli', desc: 'Install the CLI globally' }],
  },
  {
    title: 'Authentication',
    commands: [
      { cmd: 'agentwiki login --api-key aw_xxxxx', desc: 'Login with an API key' },
      {
        cmd: 'agentwiki login --api-key aw_xxxxx --url https://custom.domain',
        desc: 'Login to custom instance',
      },
      { cmd: 'agentwiki whoami', desc: 'Show current authenticated user' },
    ],
  },
  {
    title: 'Documents',
    commands: [
      { cmd: 'agentwiki doc list', desc: 'List all documents' },
      { cmd: 'agentwiki doc list --limit 10 --offset 0', desc: 'Paginated document list' },
      { cmd: 'agentwiki doc get <id>', desc: 'Get document by ID' },
      { cmd: 'agentwiki doc get <id> --json', desc: 'Get document as JSON' },
      { cmd: 'agentwiki doc get <id> --markdown', desc: 'Get document as markdown' },
      {
        cmd: 'agentwiki doc create --title "My Doc" --description "Short useful summary" --content "# Hello"',
        desc: 'Create new document',
      },
      {
        cmd: 'agentwiki doc share <id> --expires 365',
        desc: 'Create tokenized public-read link for private or shared doc',
      },
      {
        cmd: 'agentwiki doc publish <id> --description "Public reader summary"',
        desc: 'Publish document as public app page',
      },
      {
        cmd: 'agentwiki doc update <id> --content "Updated content"',
        desc: 'Update document content',
      },
      { cmd: 'agentwiki doc update <id> --title "New Title"', desc: 'Rename document' },
      { cmd: 'agentwiki doc delete <id>', desc: 'Delete document (soft delete)' },
    ],
  },
  {
    title: 'Search',
    commands: [
      { cmd: 'agentwiki search "query term"', desc: 'Hybrid search (keyword + semantic)' },
      { cmd: 'agentwiki search "query" --type keyword', desc: 'Keyword-only search' },
      { cmd: 'agentwiki search "query" --type semantic', desc: 'Semantic search via embeddings' },
    ],
  },
  {
    title: 'Source-backed repository and vault sync',
    commands: [
      {
        cmd: 'agentwiki sync docs . --dry-run',
        desc: 'Preview the deterministic Markdown manifest for the current repository',
      },
      { cmd: 'agentwiki sync docs . --yes', desc: 'Sync the reviewed repository manifest' },
      {
        cmd: 'agentwiki sync docs "/path/to/vault" --dry-run --namespace team-vault',
        desc: 'Preview a vault with a stable namespace before syncing it',
      },
    ],
  },
  {
    title: 'Folders',
    commands: [
      { cmd: 'agentwiki folder list', desc: 'List folder tree' },
      { cmd: 'agentwiki folder create --name "Engineering"', desc: 'Create root folder' },
      { cmd: 'agentwiki folder create --name "Sub" --parent <parentId>', desc: 'Create subfolder' },
    ],
  },
  {
    title: 'Tags',
    commands: [{ cmd: 'agentwiki tag list', desc: 'List all tags in workspace' }],
  },
  {
    title: 'Uploads',
    commands: [
      {
        cmd: 'agentwiki upload put <file-path> --description "Short useful summary"',
        desc: 'Upload a file to R2 storage',
      },
      {
        cmd: 'agentwiki upload put <file-path> --description "Short useful summary" --doc <id>',
        desc: 'Upload and attach to document',
      },
    ],
  },
  {
    title: 'Secrets',
    commands: [
      { cmd: 'agentwiki secrets list --env dev', desc: 'List masked secrets' },
      {
        cmd: 'agentwiki secrets set API_TOKEN --env dev --value "$API_TOKEN" --reason bootstrap',
        desc: 'Store encrypted secret',
      },
      {
        cmd: 'agentwiki secrets update <id> --expected-version 1 --value "$API_TOKEN" --reason rotate',
        desc: 'Append a new secret version',
      },
      {
        cmd: 'agentwiki secrets get <id> --reveal --reason debug',
        desc: 'Reveal raw value through audited path',
      },
      {
        cmd: 'agentwiki secrets export --env dev --reveal --reason smoke',
        desc: 'Export raw values with reveal controls',
      },
      {
        cmd: 'agentwiki secrets run --env dev --keys API_TOKEN --reason test -- npm test',
        desc: 'Inject granted env vars into local command',
      },
    ],
  },
]
